import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IActivationScheduleInput {
	changeActivationSchedule: (value: string) => void;
}

const ActivationScheduleInput: React.FC<IActivationScheduleInput> = ({ changeActivationSchedule }) => (
	<FormInput
		testId="ActivationScheduleInput"
		name="activationSchedule"
		label="activationScheduleLabel"
		placeholder="cronExpressionInputPlaceholder"
		maxLength={255}
		onChange={changeActivationSchedule}
	/>
);

export default React.memo(ActivationScheduleInput);
